export default __webpack_public_path__ + "images/33cec3a60a7efb124ab38ca42e86a0b4.png";